import { Task } from './types'

export const moveTaskInBoard = (
  currentTasks: Task[],
  activeId: string,
  overId: string,
  overType?: string
) => {
  const activeIndex = currentTasks.findIndex((task) => task.id === activeId)
  if (activeIndex === -1) return currentTasks

  if (overType === 'Task') {
    const overIndex = currentTasks.findIndex((task) => task.id === overId)
    if (overIndex === -1) return currentTasks

    const overColumnId = currentTasks[overIndex].columnId
    const nextTasks = [...currentTasks]
    const [activeTask] = nextTasks.splice(activeIndex, 1)

    const newOverIndex = nextTasks.findIndex((task) => task.id === overId)
    if (newOverIndex === -1) return currentTasks

    const insertAt = activeIndex < overIndex ? newOverIndex + 1 : newOverIndex

    nextTasks.splice(insertAt, 0, { ...activeTask, columnId: overColumnId })
    return nextTasks
  }

  if (overType === 'Column') {
    const nextTasks = [...currentTasks]
    const [activeTask] = nextTasks.splice(activeIndex, 1)
    nextTasks.push({ ...activeTask, columnId: overId })
    return nextTasks
  }

  return currentTasks
}
